import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

/**
 * Subtask-count glyph on a rounded `#F9FAFB` tile, shown before the
 * "{n} Subtask" label on Board cards. The glyph inherits `color()` via
 * `currentColor`; the tile fill is fixed to match the design tile.
 */
@Component({
  selector: 'lib-subtask-tile-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z"
        fill="#F9FAFB" />
      <path
        d="M13.6667 17.0007H13C11.1144 17.0007 10.1716 17.0007 9.58579 16.4149C9 15.8291 9 14.8863 9 13.0007V11.6673M9 11.6673V9.33398M9 11.6673H12.3333"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M13.667 17.0007C13.667 16.215 13.667 15.8221 13.9013 15.5781C14.1356 15.334 14.5127 15.334 15.267 15.334H16.067C16.8213 15.334 17.1984 15.334 17.4327 15.5781C17.667 15.8221 17.667 16.215 17.667 17.0007C17.667 17.7863 17.667 18.1792 17.4327 18.4233C17.1984 18.6673 16.8213 18.6673 16.067 18.6673H15.267C14.5127 18.6673 14.1356 18.6673 13.9013 18.4233C13.667 18.1792 13.667 17.7863 13.667 17.0007Z"
        stroke="currentColor" />
      <path
        d="M7.85681 5.33398H10.1425C11.5255 5.33398 11.6663 6.07394 11.6663 7.33398C11.6663 8.59403 11.5255 9.33398 10.1425 9.33398H7.85681C6.47381 9.33398 6.33301 8.59403 6.33301 7.33398C6.33301 6.07394 6.47381 5.33398 7.85681 5.33398Z"
        stroke="currentColor" />
      <path
        d="M16.9997 10.334L15.6663 11.6673M15.6663 11.6673L14.333 13.0007M15.6663 11.6673L16.9997 13.0007M15.6663 11.6673L14.333 10.334"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class SubtaskTileIconComponent extends BaseIconComponent {
  override width = input<string>('24');
  override height = input<string>('24');
  override viewBox = input<string>('0 0 24 24');
  override color = input<string>('#6B7280');
}
